import {
    faBed,
    faCalendarWeek,
    faHouse,
    faVenus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import Accordion from 'react-bootstrap/Accordion';
import {
    Blood,
    Card1,
    Filter,
    General,
    Heart,
    Oxygen,
    Sugar,
    Temperature,
} from "../../../../assets/images";
import * as Constants from "../../../Helper/constants/constants";
import CustomTab from "../../../Helper/customTabs";
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
import TaskModal from "../../Modals/TaskModal/index";
import UpdateVitalsModal from "../../Modals/UpdateVitalsModal";
import Health from "../../Tabs/Health";
import Lab from "../../Tabs/Lab";
import Logs from "../../Tabs/Logs";
import Medicine from "../../Tabs/Medicine";
import Reports from "../../Tabs/Reports";
import Task from "../../Tabs/Task";


const PatientDetails = () => {
    var breadcrumData = ["Dashboard", "Cardiology", "Patient List"];
    var breadcrumItem = "Patient Details";
    const [showLogin, setShowLogin] = useState(false);
    const [showUpdateVitalModal, setShowUpdateVitalModal] = useState(false);
    const [currentTab, setCurrentTab] = useState('1');
    const tabs = [
        {
            id: 1,
            tabTitle: 'Task',
        },
        {
            id: 2,
            tabTitle: 'Reports',
        },
        {
            id: 3,
            tabTitle: 'Lab',
        },
        {
            id: 4,
            tabTitle: 'Health',
        },
        {
            id: 5,
            tabTitle: 'Logs',
        },
        {
            id: 6,
            tabTitle: 'Medicine',
        }
    ];

    return (
        <div className="patient_details_screen">
            <WithoutImageHeader
                header={Constants.PATIENT_DETAILS_HEADER}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="patient_details">
                            <div className="main_detail">
                                <div className="left_area">
                                    <div className="inner_left">
                                        <div className="img_area">
                                            <Image variant="left" src={Card1} alt="..." />
                                        </div>
                                    </div>
                                    <div className="inner_right">
                                        <div className="name">
                                            <h3>Patient Name</h3>
                                        </div>
                                        <div className="gender">
                                            <p><FontAwesomeIcon icon={faVenus} className="gender_icon" />Female</p>
                                            <p><span>Cardiology</span></p>
                                            <p className="general"><Image src={General} alt="..." /> General</p>
                                        </div>
                                        <div className="date">
                                            <p><FontAwesomeIcon icon={faCalendarWeek} className="date_icon" />5 July,2023 </p>
                                            <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                            <p><FontAwesomeIcon icon={faHouse} className="date_icon ps-4" />Room #05</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="right_area">
                                    <div className="id_area">
                                        <p>UHID : 54674857</p>
                                    </div>
                                    <div className="batch">
                                        <p>Under Treatment</p>
                                    </div>
                                </div>
                            </div>
                            <div className="health_area">
                                <div className="title_area">
                                    <h5>Health Overview</h5>
                                    <p>Last Update : 5 July, 2023  11:00AM</p>
                                </div>
                                <div className="cards_area">
                                    <Row>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                            <div className="card_inner_area">
                                                <div className="sub_area">
                                                    <div className="left_area heart">
                                                        <div className="img_area">
                                                            <Image src={Heart} alt="..." />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Heart Rate</h5>
                                                    </div>
                                                </div>
                                                <div className="bottom_area">
                                                    <p><span >89</span>bpm</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                            <div className="card_inner_area">
                                                <div className="sub_area">
                                                    <div className="left_area blood">
                                                        <div className="img_area bloood">
                                                            <Image src={Blood} alt="..." />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Blood Pressure</h5>
                                                    </div>
                                                </div>
                                                <div className="bottom_area">
                                                    <p><span >102</span>/72 mmhg</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={12}>
                                            <div className="card_inner_area">
                                                <div className="sub_area">
                                                    <div className="left_area">
                                                        <div className="img_area">
                                                            <Image src={Temperature} alt="..." />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Temperature</h5>
                                                    </div>
                                                </div>
                                                <div className="bottom_area">
                                                    <p><span class="circle">80</span>Celsius</p>
                                                </div>
                                            </div>
                                        </Col>

                                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                            <div className="card_inner_area">
                                                <div className="sub_area">
                                                    <div className="left_area oxygen">
                                                        <div className="img_area bloood">
                                                            <Image src={Oxygen} alt="..." />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Oxygen Saturation</h5>
                                                    </div>
                                                </div>
                                                <div className="bottom_area">
                                                    <p><span >97 </span>%SpO2</p>
                                                    <p><span className="oxygen">60 </span>PRbpm</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                                            <div className="card_inner_area">
                                                <div className="sub_area">
                                                    <div className="left_area sugar">
                                                        <div className="img_area bloood">
                                                            <Image src={Sugar} alt="..." />
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <h5>Blood Sugar</h5>
                                                    </div>
                                                </div>
                                                <div className="bottom_area">
                                                    <p><span >140</span>mg/dl</p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="update_area">
                                    <div className="update_info">
                                        <p>Last updated by: <a href="javascript:;">Jospeh Jones</a></p>
                                    </div>
                                    <div className="button_area">
                                        <Button type="button" className="btn btn-primary" onClick={() => setShowUpdateVitalModal(true)}  >Update Vitals</Button>
                                        {
                                            showUpdateVitalModal ? (
                                                <UpdateVitalsModal show={showUpdateVitalModal} close={() => setShowUpdateVitalModal(false)} />
                                            ) : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="accordin_area">
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Medical Record: #1</Accordion.Header>
                                        <Accordion.Body>
                                            {/* <div className="case_detail_area">
                                            <div class="title">
                                                <h5>Case Detail</h5>
                                            </div> */}
                                            <div className="inner_area">
                                                <h5>Ebola Hemorrhagic Fever</h5>
                                                <ul>
                                                    <li className="category">
                                                        <p onClick={() => setShowUpdateVitalModal(true)}>Lorem</p>

                                                        {
                                                            showUpdateVitalModal ? (
                                                                <UpdateVitalsModal show={showUpdateVitalModal} close={() => setShowUpdateVitalModal(false)} />
                                                            ) : null
                                                        }

                                                    </li>
                                                    <li className="category color">
                                                        <p>Ispudn</p>
                                                    </li>
                                                </ul>

                                                <div className="description">
                                                    <p>
                                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi dolor ipsum, hendrerit sit amet neque nonLorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi dolor ipsum, hendrerit sit amet neque nonLorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi dolor ipsum, hendrerit sit amet neque nonLorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi dolor ipsum, hendrerit sit amet neque non
                                                    </p>
                                                </div>
                                                {/* </div> */}

                                            </div>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt laborum.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* <Accordion.Item eventKey="1">
                                            <Accordion.Header>Medical Record: #2</Accordion.Header>
                                            <Accordion.Body>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                            eiusmod tempor incididunt laborum.
                                            </Accordion.Body>
                                        </Accordion.Item> */}
                                </Accordion>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="task_btn_area">
                <CustomTab
                    tabs={tabs}
                    currentTab={currentTab}
                    setCurrentTab={(e) => setCurrentTab(e)}
                />
            </div>
            <div className="tab_details">
                <div className={parseInt(currentTab) === 1 ? 'sorting_data' : 'd-none'}>
                    <div className="left_area">
                        <p>Assigned Task</p>
                    </div>
                    <div className="right_area">
                        <div className="sort_button">
                            <Button className="btn-primary" type="submit"> Sort <Image src={Filter} alt="..." className="image_area" /> </Button>
                        </div>
                    </div>
                </div>
                <div className="custom_tab_data">
                    {parseInt(currentTab) === 1 ? <Task /> : null}
                    {parseInt(currentTab) === 2 ? <Reports /> : null}
                    {parseInt(currentTab) === 3 ? <Lab /> : null}
                    {parseInt(currentTab) === 4 ? <Health /> : null}
                    {parseInt(currentTab) === 5 ? <Logs /> : null}
                    {parseInt(currentTab) === 6 ? <Medicine /> : null}
                </div>
            </div>
            {
                showLogin ? (
                    <TaskModal show={showLogin} close={() => setShowLogin(false)} />
                ) : null
            }

        </div >
    );
};

export default PatientDetails;
